export type DelayedRegistrationHook<TFn extends (...args: any[]) => any> = {
    register: (fn: TFn) => void;
    readonly function: TFn;
};

export function createDelayedRegistrationHook<TFn extends (...args: any[]) => void>(
    name: string,
    options: { synchronous: true },
): DelayedRegistrationHook<TFn>;

export function createDelayedRegistrationHook<TFn extends (...args: any[]) => Promise<any>>(
    name: string,
    options?: { synchronous?: false },
): DelayedRegistrationHook<TFn>;

export function createDelayedRegistrationHook<TFn extends (...args: any[]) => any>(
    name: string,
    options?: { synchronous?: boolean },
): DelayedRegistrationHook<TFn> {
    const synchronous = options?.synchronous ?? false;
    let registered = false;
    let fn: TFn = ((..._args: any[]) => {
        const error = new Error(
            `DelayedRegistrationHook '${name}' was invoked before it was registered. ` +
                `Register it in registerHooks.ts after the database connection is established.`,
        );
        if (synchronous) throw error;
        return Promise.reject(error);
    }) as unknown as TFn;

    return {
        register(newFn: TFn) {
            if (registered) {
                throw new Error(
                    `DelayedRegistrationHook '${name}' has already been registered. ` +
                        `Each hook must be registered exactly once.`,
                );
            }
            registered = true;
            fn = newFn;
        },
        get function() {
            return fn;
        },
    };
}
